export default [{
    name: "零碳岛分类",
    route: "/carbon/carbon-class",
    icon: "carousel",
  },];
